if (!customElements.get('carousel-hub')) {
  customElements.define('carousel-hub', class carouselHub extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this._setupEventListeners();
    }

    getConnectons() {
      return [
        this.querySelector('product-images-thumbnails'),
        this.querySelector('product-carousel')
      ]
    }

    _setupEventListeners() {
      this.addEventListener('slideChanged', (e) => {
        let slideId = e.detail.slideId;
        let target = e.detail.target;
        let connectedCarousels = this.getConnectons();
        for(let connectedCarousel of connectedCarousels) {
          if(target && target === connectedCarousel) continue;
          connectedCarousel.slideTo(slideId, true); 
        }
      })
    }
  });
}
